import tokeys from 'tokeys';

export const ErrorSeverity = tokeys(['Warning', 'Error', 'Fatal']);
